/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Asset business glossary from external providers.
 */
export type PublicExternalTermReferenceDto = {
    /**
     * Id of the referenced object
     */
    id?: string;
    /**
     * Type of the referenced tag
     */
    kind?: PublicExternalTermReferenceDto.kind;
    /**
     * Name of the referenced object
     */
    name?: string;
};

export namespace PublicExternalTermReferenceDto {

    /**
     * Type of the referenced tag
     */
    export enum kind {
        ATLAN_EXTERNAL = 'ATLAN_EXTERNAL',
        ALATION_EXTERNAL = 'ALATION_EXTERNAL',
        AMUNDSEN_EXTERNAL = 'AMUNDSEN_EXTERNAL',
        APACHE_ATLAS_EXTERNAL = 'APACHE_ATLAS_EXTERNAL',
        CASTOR_DOC_EXTERNAL = 'CASTOR_DOC_EXTERNAL',
        COLLIBRA_EXTERNAL = 'COLLIBRA_EXTERNAL',
        DATAGALAXY_EXTERNAL = 'DATAGALAXY_EXTERNAL',
        INFORMATICA_EXTERNAL = 'INFORMATICA_EXTERNAL',
        SECODA_EXTERNAL = 'SECODA_EXTERNAL',
        SELECT_STAR_EXTERNAL = 'SELECT_STAR_EXTERNAL',
        GENERIC_CATALOG_EXTERNAL = 'GENERIC_CATALOG_EXTERNAL',
    }


}
